import { createContext, useContext } from "react";
import { InsideMapsConfigStore } from "../store/InsideMapsConfigStore";

const InsideMapsConfigContext = createContext<InsideMapsConfigStore | null>(null);

export const InsideMapsConfigProvider = InsideMapsConfigContext.Provider;

export function useInsideMapsConfig(): InsideMapsConfigStore {
  const store = useContext(InsideMapsConfigContext);
  if (!store) throw new Error("useInsideMapsConfig must be used within InsideMapsConfigProvider");
  return store;
}
